import { render, staticRenderFns } from "./quickbook.vue?vue&type=template&id=81634df4&"
import script from "./quickbook.vue?vue&type=script&lang=js&"
export * from "./quickbook.vue?vue&type=script&lang=js&"
import style0 from "./quickbook.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports